<div class="loader-container">
    <div class="progress-bar" [ngStyle]="{ width: mainLabel || 0 }"></div>
</div>
